import { render, staticRenderFns } from "./translate-lang-panel.vue?vue&type=template&id=fc28b998&scoped=true"
import script from "./translate-lang-panel.vue?vue&type=script&lang=js"
export * from "./translate-lang-panel.vue?vue&type=script&lang=js"
import style0 from "./translate-lang-panel.vue?vue&type=style&index=0&id=fc28b998&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc28b998",
  null
  
)

export default component.exports